import { v4 } from 'uuid';
import type { KnownAppNotificationTypes } from './_known_app_notification_types';

export abstract class ApplicationNotification<T extends string = KnownAppNotificationTypes> {
	public readonly guid: string;
	public abstract readonly event: T;

	constructor(sid?: string) {
		this.guid = sid ?? v4();
	}
}

export interface ApplicationNotificationSpecificationBase<_T extends ApplicationNotification> {
	guid?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
export type ImplementRecordWithKnownKeys<T extends string | number | symbol, K extends Record<T, any>> = { [key in keyof K]: K[key] };
